import React, { useState } from "react";
import { Image, Button, Icon, Confirm } from "semantic-ui-react";
import { image } from "../../../../datos";
import { User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal } from "../../../Shared/";
import { ENV } from "../../../../utils";
import { UserForm } from "../UserForm";
// import "./UserItem.scss";

const userController = new User();

export function UserItem(props) {
  const { user,  onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const onOpenCloseModal = () => setShowModal(!showModal);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateUser = () => {
    setTitleModal(`Actualizar ${user.email}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setIsDelete(false);
    setConfirmMessage(
      user.active
        ? `Desactivar usuario ${user.email}`
        : `Activar usuario ${user.email}`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await userController.updateUser(accessToken, user._id, {
        active: !user.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(`Eliminar usuario ${user.email}`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await userController.deleteUser(accessToken, user._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  // console.log(`${ENV.BASE_PATH}/${user.avatar}`);

  return (
    <>
      <div className="flex items-center py-1 border-b border-gray-200">
        <Image
          className="flex-shrink-0"
          avatar
          src={user.avatar ? `${ENV.BASE_PATH}/${user.avatar}` : image.noAvatar}
        />

        <div className="ml-1 flex-1">
          <p>
            {user.name} {user.lastname}
          </p>
          <p>{user.email}</p>
        </div>

        <Button icon primary onClick={openUpdateUser}>
          <Icon name="pencil" />
        </Button>
        <Button
          icon
          color={user.active ? "orange" : "teal"}
          onClick={openDesactivateActivateConfim}
        >
          <Icon name={user.active ? "ban" : "check"} />
        </Button>
        <Button icon color="red" onClick={openDeleteConfirm}>
          <Icon name="trash" />
        </Button>
      </div>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <UserForm close={onOpenCloseModal} onReload={onReload} user={user} />
      </BasicModal>

      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
